module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "c-header"
  }, [_c('div', {
    staticClass: "c-header__inner"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "c-header__show-menu",
    class: {
      '-open': _vm.showMenu
    },
    on: {
      "click": function($event) {
        _vm.showMenu = !_vm.showMenu
      }
    }
  }, [_c('c-icon', {
    attrs: {
      "name": 'chevron-down'
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "c-header-menu"
    }
  }, [_c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "c-header-menu"
  }, [_c('ul', {
    staticClass: "c-header-menu__list"
  }, _vm._l((_vm.apps), function(app) {
    return _c('li', [_c('a', {
      attrs: {
        "href": app.path
      }
    }, [_vm._v(_vm._s(app.name))])])
  }))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "c-header__title"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/img/svg/logo.svg",
      "alt": "CoDogue"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f213e8e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/component/header.vue
// module id = 65
// module chunks = 0